// extracted by mini-css-extract-plugin
export default {"error":"TextArea_error__EnL-S","errorMessage":"TextArea_errorMessage__h0kbr"};